export default __webpack_public_path__ + "static/media/img2.6f42bad1.jpg";